import React from "react";
import AdminPanel from "../shared/AdminPanel";
import panelStyles from "../styles/Panel.module.css";
import styles from "../styles/ConfigEditors.module.css";
import {
  ROULETTE_ACCENT_PRESETS,
  ROULETTE_ICON_PRESETS
} from "../constants";

function joinClasses(...values) {
  return values.filter(Boolean).join(" ");
}

function RouletteSectionBody({ state, actions }) {
  const { rouletteLoading, rouletteSaving, rouletteDirty, rouletteTab, prizes } = state;

  return (
    <>
      <div className={styles.tabs}>
        {["free", "paid"].map((tab) => (
          <button
            key={tab}
            type="button"
            className={rouletteTab === tab ? styles.tabActive : styles.tab}
            onClick={() => actions.setRouletteTab(tab)}
          >
            {tab === "free" ? "Бесплатная" : "Платная"}
          </button>
        ))}
      </div>

      <div className={styles.row}>
        <button
          type="button"
          className={panelStyles.buttonSecondary}
          onClick={actions.reload}
          disabled={rouletteLoading}
        >
          {rouletteLoading ? "Обновляем..." : "Перезагрузить"}
        </button>
        <button
          type="button"
          className={panelStyles.button}
          onClick={actions.save}
          disabled={!rouletteDirty || rouletteSaving}
        >
          {rouletteSaving ? "Сохраняем..." : "Сохранить"}
        </button>
      </div>

      <button type="button" className={panelStyles.buttonSecondary} onClick={actions.addPrize}>
        Добавить приз
      </button>

      {prizes.length > 0 ? (
        <div className={styles.cardList}>
          {prizes.map((prize, index) => (
            <div key={prize.id || `${rouletteTab}-${index}`} className={styles.card}>
              <div className={styles.cardHeader}>
                <strong>{prize.label || `Приз #${index + 1}`}</strong>
                <div className={styles.cardActions}>
                  <button type="button" className={panelStyles.buttonSecondary} onClick={() => actions.removePrize(index)}>
                    Удалить
                  </button>
                </div>
              </div>

              <div className={styles.rowThree}>
                <input
                  type="text"
                  className={panelStyles.input}
                  placeholder="Название"
                  value={prize.label || ""}
                  onChange={(event) => actions.updatePrize(index, { label: event.target.value })}
                />
                <select
                  className={panelStyles.select}
                  value={prize.rarity || "common"}
                  onChange={(event) => actions.updatePrize(index, { rarity: event.target.value })}
                >
                  <option value="common">обычный</option>
                  <option value="rare">редкий</option>
                  <option value="epic">эпический</option>
                  <option value="legendary">легендарный</option>
                </select>
                <input
                  type="number"
                  className={panelStyles.input}
                  placeholder="Вес"
                  value={prize.weight ?? 0}
                  onChange={(event) => actions.updatePrize(index, { weight: Number(event.target.value) })}
                />
              </div>

              <div className={styles.rowThree}>
                <select
                  className={panelStyles.select}
                  value={prize.type || "tokens"}
                  onChange={(event) => actions.updatePrize(index, { type: event.target.value })}
                >
                  <option value="tokens">Токены</option>
                  <option value="discount">Скидка</option>
                  <option value="money">Деньги</option>
                  <option value="text">Текст</option>
                  <option value="sticker">Стикер</option>
                  <option value="subscription">Подписка</option>
                </select>
                <input
                  type="number"
                  className={panelStyles.input}
                  placeholder="Значение"
                  value={prize.value ?? 0}
                  onChange={(event) => actions.updatePrize(index, { value: Number(event.target.value) })}
                />
                <input
                  type="text"
                  className={panelStyles.input}
                  placeholder="ID"
                  value={prize.id || ""}
                  onChange={(event) => actions.updatePrize(index, { id: event.target.value })}
                />
              </div>

              {prize.type === "subscription" ? (
                <div className={styles.row}>
                  <input
                    type="number"
                    className={panelStyles.input}
                    placeholder="Тариф"
                    value={prize.plan ?? 0}
                    onChange={(event) => actions.updatePrize(index, { plan: Number(event.target.value) })}
                  />
                  <input
                    type="number"
                    className={panelStyles.input}
                    placeholder="Дней"
                    value={prize.days ?? 0}
                    onChange={(event) => actions.updatePrize(index, { days: Number(event.target.value) })}
                  />
                </div>
              ) : null}

              <textarea
                rows={4}
                className={panelStyles.textarea}
                placeholder="Текст выигрыша"
                value={prize.message || ""}
                onChange={(event) => actions.updatePrize(index, { message: event.target.value })}
              />

              <div className={styles.accentGrid}>
                {ROULETTE_ACCENT_PRESETS.map((color) => (
                  <button
                    key={`${color}-${index}`}
                    type="button"
                    className={styles.accentChip}
                    style={{ backgroundColor: color }}
                    title={color}
                    onClick={() => actions.updatePrize(index, { accent: color })}
                  />
                ))}
              </div>

              <div className={styles.iconGrid}>
                {ROULETTE_ICON_PRESETS.map((icon) => (
                  <button
                    key={`${icon}-${index}`}
                    type="button"
                    className={joinClasses(styles.iconChip, prize.icon === icon ? styles.tabActive : "")}
                    onClick={() => actions.updatePrize(index, { icon })}
                  >
                    {icon.split("/").pop()}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.empty}>Призы еще не настроены.</div>
      )}
    </>
  );
}

export function RouletteSection({ mode = "panel", isOpen = true, onToggle, state, actions }) {
  if (mode === "page") {
    return <RouletteSectionBody state={state} actions={actions} />;
  }

  return (
    <AdminPanel id="roulette" title="Рулетка" isOpen={isOpen} onToggle={onToggle}>
      <RouletteSectionBody state={state} actions={actions} />
    </AdminPanel>
  );
}

export default RouletteSection;
